/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

export type Feature = (typeof Feature)[keyof typeof Feature];

export const Feature = {
  concierge: "concierge",
  financial_accounts: "financial_accounts",
  mcp: "mcp",
  assistant: "assistant",
  receipt_ai: "receipt_ai",
} as const;
